import React from "react";
import config from "../../../config";
import { ApiHandlerPureComponent } from "./ApiHandlerPureComponent";
import { Customer, EnhancedCustomerSubmission } from "../interfaces/Customer";
import { AlternativeRegionNames, AlternativeRegionNamesSubmission } from "../interfaces/AlternativeRegionNames";

interface Props {
  onAuthError?: () => void;
}
export default class CustomerApis extends React.PureComponent<Props> {
  private apiResponseHandler = new ApiHandlerPureComponent({
    onAuthError: this.props.onAuthError,
  });

  private static readonly BASE_URL: string = `${config.apiGateway.META_API}/api/Customers/`;

  getCustomers = (): Promise<Customer[]> => {
    return this.apiResponseHandler.get(CustomerApis.BASE_URL).then((data) => {
      if (!data) {
        return [];
      }
      if (!Array.isArray(data)) {
        return [];
      }
      return data;
    });
  };

  getAlternativeRegionNames = (customerId: number): Promise<AlternativeRegionNames> => {
    const apiCustomers = `${CustomerApis.BASE_URL}attributes/${customerId}/alternativeRegionNames`;
    return this.apiResponseHandler.get(apiCustomers);
  };

  updateAlternativeRegionNames = async (
    altRegionNamesSubmission: AlternativeRegionNamesSubmission,
  ): Promise<number> => {
    const apiCustomers = `${CustomerApis.BASE_URL}attributes/${altRegionNamesSubmission.customerId}/alternativeRegionNames`;
    return this.apiResponseHandler.put(apiCustomers, JSON.stringify(altRegionNamesSubmission.altRegionNames), false);
  };

  createEnhancedCustomer = async (customer: EnhancedCustomerSubmission, isLvCustomer = false): Promise<number> => {
    const apiCustomers = `${CustomerApis.BASE_URL}Enhanced?lvCustomer=${isLvCustomer}`;
    return this.apiResponseHandler.post(apiCustomers, JSON.stringify(customer), false);
  };
}
